import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Footer.css";
import { buildWebsiteUrl, WEBSITE_BASE_URL } from "../../apis/apiKit";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/i18n";

const Footer = () => {
  const { t } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <div className="responsive-container-footer backgroundColorBlue">
      <div className="container">
        <div className="pb-4">
          <img
            src={require("../../assets/images/GME-Logo-w.png")}
            alt="Greenman Energy Logo"
            className="height70"
            onClick={() => {
              window.open(
                currentLanguage == "en"
                  ? WEBSITE_BASE_URL + "/homepage/"
                  : WEBSITE_BASE_URL
              );
            }}
          />
        </div>

        <footer className="text-white backgroundColorBlue ">
          <div>
            <div className="row pb-4 px-4 footer-margin">
              <div className="col-12 col-md-4 mb-2 mb-md-0">
                <address className="fontSize12Regular lineHeight24 mb-0">
                  {t("Greenman Energy Operations GmbH & Co. KG")}
                  <br />
                  {t("Ida-Ehre-Platz 14, 20095 Hamburg")}
                  <br />
                  {t("HRB 237399 B")}
                  <br />
                  <a
                    href="mailto:enquiry@greenman.energy"
                    className="text-white text-decoration-none fontSize12Regular lineHeight24"
                  >
                    enquiry@greenman.energy
                  </a>
                  <br />
                  <a
                    href="https://www.greenman.energy"
                    className="textGreen text-decoration fontSize12Regular lineHeight24"
                  >
                    www.greenman.energy
                  </a>
                </address>
              </div>

              <div className="d-none d-md-block col-md-1">
                <div
                  className="border-start border-green h-100 mx-auto"
                  style={{ borderWidth: "1px" }}
                ></div>
              </div>

              {/* Nav Links */}
              <div className="col-6 col-md-2 mb-3">
                <ul className="list-unstyled fontSize12Regular lineHeight24 mb-0">
                  <li className=" mb-md-0">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/for-home"
                          : "/fur-privathaushalte/"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("For Home")}
                    </a>
                  </li>
                  <li className=" mb-md-0">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/for-business"
                          : "/fur-geschaeftskunden/"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("For Business")}
                    </a>
                  </li>
                  <li className=" mb-md-0">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/e-mobility"
                          : "/e-mobilitaet/"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("E-Mobility")}
                    </a>
                  </li>
                  <li className=" mb-md-0">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/our-company"
                          : "/ueber-uns/unser-unternehmen/"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("Our Company")}
                    </a>
                  </li>
                  <li>
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/our-energy-network"
                          : "/ueber-uns/unser-energienetz/"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("Our Energy Network")}
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-6 col-md-2 mb-3">
                <ul className="list-unstyled fontSize12Regular lineHeight24 mb-0">
                  <li className=" mb-md-0">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/help-support"
                          : "/hilfe-support/"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("Help & Support")}
                    </a>
                  </li>
                  {/* No link added as not provided in Figma */}
                  <li className=" mb-md-0">
                    <a
                      href="https://portal.greenman.energy/"
                      className="text-white text-decoration-none"
                      target="_blank"
                    >
                      {t("Customer Portal")}
                    </a>
                  </li>
                  <li className=" mb-md-0">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/help-support/#Contactus"
                          : "/hilfe-support/#Contactus"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("Contact")}
                    </a>
                  </li>
                  <li className=" mb-md-0">
                    <a
                      href={buildWebsiteUrl(
                        currentLanguage == "en"
                          ? "/news-room"
                          : "/ueber-uns/aktuelles/#/"
                      )}
                      className="text-white text-decoration-none"
                    >
                      {t("News Room")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://thegreenman.group/"
                      target="_blank"
                      className="text-white text-decoration-none"
                    >
                      {t("The Greenman Group")}
                    </a>
                  </li>
                </ul>
              </div>

              {/* Social Links & Legal */}
              <div className="col-12 col-md-3 d-flex flex-column align-items-start align-items-md-end">
                {/* LinkedIn */}
                <div className="mb-2 mb-md-4">
                  <a
                    href="https://www.linkedin.com/company/greenman-energy/"
                    className="text-white d-inline-flex align-items-center"
                  >
                    <img
                      src={require("../../assets/images/green_linkedin.png")}
                      alt="LinkedIn"
                      width="30"
                      height="30"
                    />
                  </a>
                </div>
                {/* Legal Links */}
                <div className="d-flex align-items-center gap-2 fontSize12Regular lineHeight24  mb-md-0">
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en"
                        ? "/privacy-statement"
                        : "/datenschutz/"
                    )}
                    className="text-white text-decoration-none fontSize12Regular lineHeight24"
                  >
                    {t("Privacy")}
                  </a>
                  <span className="textGreen">|</span>
                  <a
                    href={buildWebsiteUrl(
                      currentLanguage == "en" ? "/imprint" : "/impressum/"
                    )}
                    className="text-white text-decoration-none fontSize12Regular lineHeight24"
                  >
                    {t("Imprint")}
                  </a>
                </div>

                {/* Copyright */}
                <div className="fontSize12Regular lineHeight24 text-white">
                  {t("© Copyright 2025 Greenman Energy")}
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Footer;
